import React, { Component } from 'react'

import MaterialIcon, { colorPalette } from 'material-icons-react';
import TreeMapDelayWidget from "../../components/Widgets/TreeMapDelayWidget";
import Row from "react-bootstrap/es/Row";
import Col from "react-bootstrap/es/Col";
import HttpClient from "../../utils/HttpClient/HttpClient";


import { formatToDecimal, roundNumber } from "utils/Number/NumberUtils"

export default class DashBoardView extends Component {

    httpClient;
    widgetHelper;
    constructor(props) {
        super(props);
        this.state = {
            widgetIds: null,
            rank: null,
            commissions: null,
            counter: null,
            due: null,
            race: null
        };

        this.httpClient = new HttpClient(true);
    }


    componentWillMount() {
        this.httpClient.get("oga/affiliate/ranks").then((response) => {
            console.log(response.data);
            this.setState({ rank: response.data });

        }).catch((error) => {
            console.error("oga/affiliate/rankss", error);
        });

        this.httpClient.get("oga/affiliate/commissions").then((response) => {
            console.log("oga/affiliate/commissions", response.data);

            this.setState({ commissions: response.data });

        }).catch((error) => {
            console.error("oga/affiliate/commissions", error);
        });

        this.httpClient.get("oga/affiliate/counter").then((response) => {
            console.log("oga/affiliate/counter", response.data);

            this.setState({ counter: response.data });

        }).catch((error) => {
            console.error("oga/affiliate/counter", error);
        });

        this.httpClient.get("oga/affiliate/due").then((response) => {
            console.log("oga/affiliate/due", response.data);
            this.setState({ due: response.data });

        }).catch((error) => {
            console.error("oga/affiliate/due", error);
        });

        this.httpClient.get("oga/affiliate/race").then((response) => {
            console.log("oga/affiliate/race", response.data);
            this.setState({ race: response.data });

        }).catch((error) => {
            console.error("oga/affiliate/race", error);
        });

    }

    getRankArrow(key, fill) {
        let fillClass = fill ? "#ff9100" : "white";
        let strokeClass = fill ? "none" : "#4a148c";
        return (
            <div key={key}>
                <svg width="67" height="40" viewBox="0 0 67 63" fill={`${fillClass}`}>
                    <path d="M24.1587 30.6855L1.79092 4.29309C0.689553 2.99356 1.6132 1 3.31667 1H39.8006C40.3884 1 40.9464 1.25853 41.3264 1.70691L65.886 30.6855C66.5262 31.441 66.5172 32.5513 65.8648 33.2963L41.3248 61.3177C40.9451 61.7513 40.3967 62 39.8203 62H3.41005C1.69133 62 0.773117 59.9753 1.90546 58.6824L24.1375 33.2963C24.79 32.5513 24.799 31.441 24.1587 30.6855Z"
                        stroke={`${strokeClass}`} />
                </svg>
            </div>
        )
    }


    render() {
        let rank = this.state.rank;
        let commissions = this.state.commissions;
        let counter = this.state.counter;
        let due = this.state.due;
        let race = this.state.race;
        let rAcount;
        let nAcount;
        let directValue;
        let networkValue;
        if (rank) {
            rAcount = rank.remainingDirectAffiliates;
            nAcount = rank.remainingNetworkAffiliates;
            directValue = rAcount > 1 ? `Te faltan ${rAcount} afiliados directos` :
                rAcount === 1 ? "Te falta un afiliado directo" : "";
            networkValue = nAcount > 1 ? `Te faltan ${nAcount} afiliados de red` :
                nAcount === 1 ? "Te falta un afiliado de red" : "";
        }
        return (
            <div>
                <Row className="no-padding no-margin">

                    {
                        !rank ? null :
                            <Col lg={5} className="no-padding no-margin ds-col-spacing">
                                <div className="ds-container bg-primary text-white so-shadow border rounded inline-block w-100">
                                    <div className="ds-inline-container">
                                        <div className="ds-round rounded-circle ds-center bg-secondary ">
                                            {rank.rank}
                                        </div>
                                        <div className="ds-separator ds-center ">
                                            {
                                                !rank ? null : [3, 2, 1].map((i) => {
                                                    return this.getRankArrow(i, rAcount < i)
                                                })
                                            }
                                        </div>
                                        <div className="ds-round rounded-circle ds-center bg-light-secondary">
                                            {rank.rank + 1}
                                        </div>

                                    </div>
                                    <div className="block">
                                        {
                                            rAcount <= 0 ? null :
                                                <div className="w-100 ds-center">{directValue}</div>
                                        }

                                        {
                                            nAcount <= 0 ? null :
                                                <div className="w-100 ds-center">{networkValue}</div>
                                        }
                                    </div>
                                </div>
                            </Col>

                    }
                    {
                        !counter ? null :
                            <Col lg={7} className="no-padding no-margin">
                                <div className="ds-container bg-light-primary text-white so-shadow border rounded inline-block w-100">
                                    <div className="block">
                                        <div className="clearfix">
                                            <div className="float-left">Total de afiliados en tu red: (Contratos sin ejecución)</div>
                                            <div className="float-right">{counter.totalAffiliates}</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Cantidad de afiliados directos:</div>
                                            <div className="float-right">{counter.directAffiliates}</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Cantidad de afiliados por la red:</div>
                                            <div className="float-right">{counter.networkAffiliates}</div>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                    }

                    {
                        !commissions ? null :
                            <Col lg={5} className="no-padding no-margin ds-col-spacing">
                                <div className="ds-container bg-primary text-white  so-shadow border rounded inline-block w-100">
                                    <div className="block">
                                        <div className="clearfix">
                                            <div className="float-left">Ingresos acumulados:</div>
                                            <div className="float-right">{formatToDecimal(roundNumber(commissions.totalAmount))} Bs.</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Acumulado de comisiones de impacto:</div>
                                            <div className="float-right">{formatToDecimal(roundNumber(commissions.impactAmount))} Bs.</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Acumulado de comisiones residuales:</div>
                                            <div className="float-right">{formatToDecimal(roundNumber(commissions.residualAmount))} Bs.</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Acumulado de bono cúspide:</div>
                                            <div className="float-right">{formatToDecimal(roundNumber(commissions.bonusAmount))} Bs.</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left" style={ {color: "#4a148c"}}>_</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                    }

                    {
                        !due ? null :
                            <Col lg={7} className="no-padding no-margin">
                                <div className="ds-container bg-light-primary text-white  so-shadow border rounded inline-block w-100">
                                    <div className="block">
                                        <div className="clearfix">
                                            <div className="float-left">Estado de Venta:</div>
                                            <div className="float-right">
                                                {
                                                    due.paid ? <span className="badge badge-pill badge-paid">Pagado</span> :
                                                    due.onTime ? <span className="badge badge-pill badge-success">Al día</span> :
                                                        <span className="badge badge-pill badge-danger">En Mora</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Estado para Comisiones:</div>
                                            <div className="float-right">
                                                {
                                                    due.active ? <span className="badge badge-pill badge-success">Activo</span> :
                                                        <span className="badge badge-pill badge-danger">Inactivo</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Fecha de pago:</div>
                                            <div className="float-right">{due.paymentDate}</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Días restantes para pagar la cuota:</div>
                                            <div className="float-right">{due.remainingDaysToPayQuota}</div>
                                        </div>
                                        <div className="clearfix">
                                            <div className="float-left">Días restantes de ganancias:</div>
                                            <div className="float-right">{due.residualDays}</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                    }

                    {
                        !race ? null :
                            <Col lg={5} className="no-padding no-margin ds-col-spacing">
                                <div className="ds-container bg-primary text-white  so-shadow border rounded inline-block w-100">
                                    <div className="block">
                                        <div className="clearfix">
                                            <div className="float-left">Bonificaciones Carrera OGA</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusFifty ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO 50 USD:</div>
                                            <div className="float-right">{race.bonusFifty} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusOneHundred ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO 100 USD:</div>
                                            <div className="float-right">{race.bonusOneHundred} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusTwoHundred ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO 200 USD:</div>
                                            <div className="float-right">{race.bonusTwoHundred} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusThreeHundred ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO 300 USD:</div>
                                            <div className="float-right">{race.bonusThreeHundred} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusSmartphone ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO Smartphone:</div>
                                            <div className="float-right">{race.bonusSmartphone} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusLaptop ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO Laptop:</div>
                                            <div className="float-right">{race.bonusLaptop} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusAllInclusive ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO All Inclusive:</div>
                                            <div className="float-right">{race.bonusAllInclusive} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusCar ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO Auto 0 KM:</div>
                                            <div className="float-right">{race.bonusCar} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusLand ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO Terreno:</div>
                                            <div className="float-right">{race.bonusLand} Días</div>
                                        </div>
                                        <div className="clearfix" style={race.bonusHouse ? {} : { display: 'none' }} >
                                            <div className="float-left">Precalificado a BONO Casa:</div>
                                            <div className="float-right">{race.bonusHouse} Días</div>
                                        </div>

                                        <div className="clearfix" style={{color : '#ffc246' }}>
                                            <div className="float-left">Recuerda estar Activo para recibir las bonificaciones de la carrera Oga.</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                    }

                </Row>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/DashBoard/StaticTopDashboard.jsx